export const QUALITATIVE_NOTES = Object.freeze({
    PRODUCTION_JOB: 10,
    PRODUCTION_SCHEDULE: 20,
    FACTORY_BASE_JOB: 30
})

export const JOB_REPORT_ITEM_TYPE_IDS = [
    QUALITATIVE_NOTES.PRODUCTION_JOB,
    QUALITATIVE_NOTES.PRODUCTION_SCHEDULE,
    QUALITATIVE_NOTES.FACTORY_BASE_JOB
]
